module.exports = __webpack_public_path__ + "fa-brands-400.1d5619cd804367cefe6d.svg";


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/assets/fonts/fontawesome/fa-brands-400.svg
// module id = ../../../../../src/assets/fonts/fontawesome/fa-brands-400.svg
// module chunks = main